var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"my-1",class:_vm.btnColorSetter(_vm.value)},[_vm._v(" "+_vm._s(_vm.value == true ? "Enabled" : "Disabled")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }